import { render, staticRenderFns } from "./jobseekers.vue?vue&type=template&id=87e02dbc"
import script from "./jobseekers.vue?vue&type=script&lang=js"
export * from "./jobseekers.vue?vue&type=script&lang=js"
import style0 from "./jobseekers.vue?vue&type=style&index=0&id=87e02dbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports